import { Link } from "react-router-dom";
import { LegalLayout } from "@/components/legal/LegalLayout";
import { LegalP, LegalSection, LegalUl } from "@/components/legal/LegalProse";
import { CONTACT, OPERATOR } from "@/lib/legal";
import { tw } from "@/lib/theme";

export function ChildSafetyPage() {
  return (
    <LegalLayout
      title="Child safety & CSAE policy"
      subtitle="Standards against child sexual abuse and exploitation (CSAE)."
    >
      <LegalSection title="Age requirement">
        <LegalP>
          {OPERATOR.product} is not for children under <strong>13</strong>. Users between 13 and 18
          should use the service with a parent or guardian&apos;s guidance where required by local
          law.
        </LegalP>
      </LegalSection>

      <LegalSection title="Zero tolerance">
        <LegalP>
          Child sexual abuse material (CSAM) and child sexual abuse and exploitation (CSAE) are
          strictly prohibited. We remove such content, preserve evidence as law requires, disable
          offending accounts, and report to appropriate authorities including Indian law
          enforcement and NCMEC where applicable.
        </LegalP>
      </LegalSection>

      <LegalSection title="How to report">
        <LegalUl
          items={[
            "In-app: Report the post, profile, or message immediately.",
            <>
              Email{" "}
              <a href={`mailto:${CONTACT.support}`} className={tw.link}>
                {CONTACT.support}
              </a>{" "}
              or{" "}
              <a href={`mailto:${CONTACT.admin}`} className={tw.link}>
                {CONTACT.admin}
              </a>{" "}
              with subject &quot;CSAE report&quot; and include URLs or usernames.
            </>,
            "Do not download or share CSAM; this may be illegal.",
          ]}
        />
      </LegalSection>

      <LegalSection title="Grooming & endangerment">
        <LegalP>
          Predatory behaviour, soliciting minors, or sharing a minor&apos;s personal information
          without consent violates our{" "}
          <Link to="/guidelines" className={tw.link}>
            Guidelines
          </Link>{" "}
          and will result in permanent bans and law-enforcement referral.
        </LegalP>
      </LegalSection>

      <LegalSection title="Operator contact">
        <LegalP>
          Child safety point of contact: <strong>{OPERATOR.name}</strong>,{" "}
          <a href={`mailto:${CONTACT.admin}`} className={tw.link}>
            {CONTACT.admin}
          </a>
          , {CONTACT.phones[0]}.
        </LegalP>
      </LegalSection>
    </LegalLayout>
  );
}
